var defaultStyles = {
  "row": "Base-Grid--Row",
  "row_variant_spaced": "Base-Grid--RowVariantSpaced",
  "row_direction_row": "Base-Grid--RowDirectionRow",
  "row_xs_direction_row": "Base-Grid--RowXsDirectionRow",
  "row_direction_column": "Base-Grid--RowDirectionColumn",
  "row_xs_direction_column": "Base-Grid--RowXsDirectionColumn",
  "row_align_start": "Base-Grid--RowAlignStart",
  "row_xs_align_start": "Base-Grid--RowXsAlignStart",
  "row_align_end": "Base-Grid--RowAlignEnd",
  "row_xs_align_end": "Base-Grid--RowXsAlignEnd",
  "row_align_center": "Base-Grid--RowAlignCenter",
  "row_xs_align_center": "Base-Grid--RowXsAlignCenter",
  "row_justify_start": "Base-Grid--RowJustifyStart",
  "row_xs_justify_start": "Base-Grid--RowXsJustifyStart",
  "row_justify_end": "Base-Grid--RowJustifyEnd",
  "row_xs_justify_end": "Base-Grid--RowXsJustifyEnd",
  "row_justify_center": "Base-Grid--RowJustifyCenter",
  "row_xs_justify_center": "Base-Grid--RowXsJustifyCenter",
  "row_justify_space-around": "Base-Grid__row_justify_space--Around",
  "row_xs_justify_space-around": "Base-Grid__row_xs_justify_space--Around",
  "row_justify_space-between": "Base-Grid__row_justify_space--Between",
  "row_xs_justify_space-between": "Base-Grid__row_xs_justify_space--Between",
  "row_justify_space-evenly": "Base-Grid__row_justify_space--Evenly",
  "row_xs_justify_space-evenly": "Base-Grid__row_xs_justify_space--Evenly",
  "row_justify_stretch": "Base-Grid--RowJustifyStretch",
  "row_xs_justify_stretch": "Base-Grid--RowXsJustifyStretch",
  "row_sm_direction_row": "Base-Grid--RowSmDirectionRow",
  "row_sm_direction_column": "Base-Grid--RowSmDirectionColumn",
  "row_sm_align_start": "Base-Grid--RowSmAlignStart",
  "row_sm_align_end": "Base-Grid--RowSmAlignEnd",
  "row_sm_align_center": "Base-Grid--RowSmAlignCenter",
  "row_sm_justify_start": "Base-Grid--RowSmJustifyStart",
  "row_sm_justify_end": "Base-Grid--RowSmJustifyEnd",
  "row_sm_justify_center": "Base-Grid--RowSmJustifyCenter",
  "row_sm_justify_space-around": "Base-Grid__row_sm_justify_space--Around",
  "row_sm_justify_space-between": "Base-Grid__row_sm_justify_space--Between",
  "row_sm_justify_space-evenly": "Base-Grid__row_sm_justify_space--Evenly",
  "row_sm_justify_stretch": "Base-Grid--RowSmJustifyStretch",
  "row_md_direction_row": "Base-Grid--RowMdDirectionRow",
  "row_md_direction_column": "Base-Grid--RowMdDirectionColumn",
  "row_md_align_start": "Base-Grid--RowMdAlignStart",
  "row_md_align_end": "Base-Grid--RowMdAlignEnd",
  "row_md_align_center": "Base-Grid--RowMdAlignCenter",
  "row_md_justify_start": "Base-Grid--RowMdJustifyStart",
  "row_md_justify_end": "Base-Grid--RowMdJustifyEnd",
  "row_md_justify_center": "Base-Grid--RowMdJustifyCenter",
  "row_md_justify_space-around": "Base-Grid__row_md_justify_space--Around",
  "row_md_justify_space-between": "Base-Grid__row_md_justify_space--Between",
  "row_md_justify_space-evenly": "Base-Grid__row_md_justify_space--Evenly",
  "row_md_justify_stretch": "Base-Grid--RowMdJustifyStretch",
  "row_lg_direction_row": "Base-Grid--RowLgDirectionRow",
  "row_lg_direction_column": "Base-Grid--RowLgDirectionColumn",
  "row_lg_align_start": "Base-Grid--RowLgAlignStart",
  "row_lg_align_end": "Base-Grid--RowLgAlignEnd",
  "row_lg_align_center": "Base-Grid--RowLgAlignCenter",
  "row_lg_justify_start": "Base-Grid--RowLgJustifyStart",
  "row_lg_justify_end": "Base-Grid--RowLgJustifyEnd",
  "row_lg_justify_center": "Base-Grid--RowLgJustifyCenter",
  "row_lg_justify_space-around": "Base-Grid__row_lg_justify_space--Around",
  "row_lg_justify_space-between": "Base-Grid__row_lg_justify_space--Between",
  "row_lg_justify_space-evenly": "Base-Grid__row_lg_justify_space--Evenly",
  "row_lg_justify_stretch": "Base-Grid--RowLgJustifyStretch",
  "row_xl_direction_row": "Base-Grid--RowXlDirectionRow",
  "row_xl_direction_column": "Base-Grid--RowXlDirectionColumn",
  "row_xl_align_start": "Base-Grid--RowXlAlignStart",
  "row_xl_align_end": "Base-Grid--RowXlAlignEnd",
  "row_xl_align_center": "Base-Grid--RowXlAlignCenter",
  "row_xl_justify_start": "Base-Grid--RowXlJustifyStart",
  "row_xl_justify_end": "Base-Grid--RowXlJustifyEnd",
  "row_xl_justify_center": "Base-Grid--RowXlJustifyCenter",
  "row_xl_justify_space-around": "Base-Grid__row_xl_justify_space--Around",
  "row_xl_justify_space-between": "Base-Grid__row_xl_justify_space--Between",
  "row_xl_justify_space-evenly": "Base-Grid__row_xl_justify_space--Evenly",
  "row_xl_justify_stretch": "Base-Grid--RowXlJustifyStretch"
};

export { defaultStyles as default };
